import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@store";
import { useLocation, useNavigate } from "react-router-dom";
import { isAuthenticated } from "@utils/auth.utils";
import { logout } from "@slices/auth.slice";
import { useAppDispatch } from "@src/redux/hooks";

export default function SecurityContext({
  children,
}: React.PropsWithChildren<{ id?: string }>) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const authentication = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (!isAuthenticated(authentication)) {
      const justLoggedOut = sessionStorage.getItem("justLoggedOut");

      if (justLoggedOut) {
        sessionStorage.removeItem("justLoggedOut");
        sessionStorage.removeItem("redirectAfterLogin");
      } else if (location.pathname !== "/login") {
        const existingRedirect = sessionStorage.getItem("redirectAfterLogin");
        console.log("location", location);
        if (!existingRedirect) {
          sessionStorage.setItem(
            "redirectAfterLogin",
            location.pathname + location.search
          );
        }
      }
      navigate("/login");
    } else {
      sessionStorage.removeItem("justLoggedOut");

      if (
        authentication.user.data &&
        authentication.user.data.expiresAt &&
        authentication.user.data.issuedAt
      ) {
        const currentTime = Math.floor(Date.now() / 1000);
        if (authentication.user.data.expiresAt <= currentTime) {
          sessionStorage.setItem("justLoggedOut", "true");
          sessionStorage.removeItem("redirectAfterLogin");
          dispatch(logout());
          navigate("/login");
        } else {
          const logoutTime =
            (authentication.user.data.expiresAt -
              authentication.user.data.issuedAt) *
            1000;
          setTimeout(() => {
            sessionStorage.setItem("justLoggedOut", "true");
            sessionStorage.removeItem("redirectAfterLogin");
            dispatch(logout());
            navigate("/login");
          }, logoutTime);
        }
      }

      if (location.pathname === "/login") {
        const redirectPath = sessionStorage.getItem("redirectAfterLogin");
        if (redirectPath && redirectPath !== "/login") {
          sessionStorage.removeItem("redirectAfterLogin");
          navigate(redirectPath);
        } else {
          sessionStorage.removeItem("redirectAfterLogin");
          navigate("/");
        }
      }
    }
  }, [authentication, location.pathname]);

  return <div>{children}</div>;
}
